import React from 'react';

import './ProcessingIndicator.scss';

const ProcessingIndicator = props => {
  const { userMessage, style = 'dark' } = props;

  const containerClasses = ['parkchirp--processing-indicator'];
  if (style) containerClasses.push(`parkchirp--processing-indicator--${style}`);

  return (
    <div className={containerClasses.join(' ')}>
      <div className="parkchirp--processing-indicator--imagery">
        {[...Array(12).keys()].map(index =>
          <div key={index} className="parkchirp--processing-indicator-tick"></div>)
        }
      </div>
      {(userMessage) &&
        <div className="parkchirp--processing-indicator--user-message" data-cy="loading-indicator">{userMessage}</div>
      }
    </div>
  );
};

export default ProcessingIndicator;
